import { endOfDay, startOfDay, addYears, addMonths, addDays, addWeeks } from "date-fns";
import { today } from 'AppReact';

export default {
  'DatePickerButtons.Today': ({ }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate: today(), })
    outlet({ selectedDate: today(), selectedYear: today().getFullYear(), selectedTimeOption: 'today' })
  },
  'DatePickerButtons.Tomorrow': ({ }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate: addDays(today(), 1) })
    outlet({ selectedDate: addDays(today(), 1), selectedYear: today().getFullYear(), selectedTimeOption: 'tomorrow' })
  },
  'DatePickerButtons.NextWeek': ({ }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate: addWeeks(today(), 1) })
    outlet({ selectedDate: addWeeks(today(), 1), selectedYear: today().getFullYear(), selectedTimeOption: 'nextWeek' })
  },
  'DatePickerButtons.NextMonth': ({ }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate: addMonths(today(), 1) })
    outlet({ selectedDate: addMonths(today(), 1), selectedYear: today().getFullYear(), selectedTimeOption: 'nextMonth' })
  },
  'DatePickerButtons.NextQuarter': ({ }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate: addMonths(today(), 3) })
    outlet({ selectedDate: addMonths(today(), 3), selectedYear: today().getFullYear(), selectedTimeOption: 'nextQuarter' })
  },
  'DatePickerButtons.NextYear': ({ }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedDate: addYears(today(), 1) })
    outlet({ selectedDate: addYears(today(), 1), selectedYear: today().getFullYear(), selectedTimeOption: 'nextYear' })
  },
  'DatePickerButtons.Custom': ({ selectedDate }, outlet, internalStateSetter) => {
    outlet({ selectedTimeOption: 'custom', selectedDate: selectedDate })
  }
}